// CORE
import React, { Component } from 'react';

// MODULES
import { 
	ModuleOne, 
	ModuleThirtyTwo, 
	ModuleFive,
	ModuleThirtyFive,
	ModuleSeven } from '../../../components/Modules';

// STYLES
import classes from '../layout.css';

class Vestibuloplasty extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne 
					addToForm={addToForm} 
					consentForm={consentForm}
				/>
				<p><strong>Please initial each paragraph after reading. If you have any questions, please ask your doctor BEFORE initialing.</strong></p>
				
				<ModuleThirtyTwo 
					addToForm={addToForm}
					consentForm={consentForm}
				/>
				<ModuleThirtyFive
					addToForm={addToForm}
					consentForm={consentForm}
				/>
				<ModuleSeven
					addToForm={addToForm}
					consentForm={consentForm}
				/>
				<h3>CONSENT</h3>
				My signature below signifies that all questions have been answered to my satisfaction regarding this consent and I fully understand the risks involved of the proposed surgery and anesthesia. I certify that I speak, read and write English.
				<ModuleFive 
					addToForm={addToForm}
					consentForm={consentForm} 
				/>
			</form>
		)
	}
}

export default Vestibuloplasty



// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/1.js